import React from 'react';
import LeagueSettings from '../LeagueSettings';

const LeagueSettingsPanel = () => (
    <div className="space-y-4">
        <LeagueSettings />
    </div>
);

export default LeagueSettingsPanel;